import { useEffect, useState } from 'react';
import { calculateExpiryTimeLeft } from 'src/common/helpers/date/date';
import { NetworkUpTimeProps } from './network-up-time.types';
export const NetworkUpTime = ({
  networkUpTime
}: NetworkUpTimeProps) => {
  const [networkUpTimeFormatted, setNetworkUpTimeFormatted] = useState(calculateExpiryTimeLeft(networkUpTime, new Date()));
  useEffect(() => {
    const interval = setInterval(() => {
      setNetworkUpTimeFormatted(calculateExpiryTimeLeft(networkUpTime, new Date()));
    }, 1000);
    return () => clearInterval(interval);
  }, [networkUpTime]);
  return <>
      {networkUpTimeFormatted.hours ? <span>{`${networkUpTimeFormatted.hours}h `}</span> : ' '}
      {networkUpTimeFormatted.minutes ? <span>{`${networkUpTimeFormatted.minutes}min`} </span> : ' '}
    </>;
};